import React from 'react';
import BorrowerOnboardingSC from './borrower-onboarding.styled';
import InfoBanner from '../../components/info-banner';
import ContentWrap from '../../components/content-wrap';
import BorrowerOnboardingBanner from '../../components/borrower-onboarding-banner';
import BorrowerOnboardingContent from '../../components/borrower-onboarding-content';

const BorrowerOnboarding = () => {
  return (
    <BorrowerOnboardingSC>
      <InfoBanner>
        <BorrowerOnboardingBanner />
      </InfoBanner>
      <ContentWrap>
        <BorrowerOnboardingContent />
      </ContentWrap>
    </BorrowerOnboardingSC>
  );
};

export default BorrowerOnboarding;
